import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import ApprovedCashLoanLayer from "../../../components/Admin/ApprovedCashLoanLayer";

const ApprovedCashLoan = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ApprovedCashLoanLayer />
      </MasterLayout>
    </>
  );
};

export default ApprovedCashLoan